import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  timer: 'data-countdown-timer',
  days: 'data-countdown-days',
  hrs: 'data-countdown-hrs',
  mins: 'data-countdown-mins',
  secs: 'data-countdown-secs',
}
const qsAll = {
  sections: 'data-section-type="countdown-banner"',
}

const initSection = (section) => {
  const timer = section.querySelector(`[${qs.timer}]`)
  if(timer.dataset.endDate) {
    const endDate = new Date(timer.dataset.endDate)
    const daysSlot = section.querySelector(`[${qs.days}]`)
    const hoursSlot = section.querySelector(`[${qs.hrs}]`)
    const minutesSlot = section.querySelector(`[${qs.mins}]`)
    const secondsSlot = section.querySelector(`[${qs.secs}]`)
    const now = new Date()
    if (endDate.getTime() - now.getTime() > 10000) {
      timer.classList.remove('!hidden')
      const countDownTimerInterval = setInterval(function(){
        var now = new Date()
        const diff = (endDate.getTime() - now.getTime()) / 1000
        if (diff > 0) {
          let days = Math.floor(diff / 3600 / 24)
          let hours = Math.floor((diff - days * 3600 * 24) / 3600)
          let minutes = Math.floor((diff - days * 3600 * 24 - hours * 3600) / 60)
          let seconds = Math.round(diff - days * 3600 * 24 - hours * 3600 - minutes * 60)
          days = (days >= 10 ? days.toString() : "0" + days.toString())
          hours = (hours >= 10 ? hours.toString() : "0" + hours.toString())
          minutes = (minutes >= 10 ? minutes.toString() : "0" + minutes.toString())
          seconds = (seconds >= 10 ? seconds.toString() : "0" + seconds.toString())
          
          daysSlot.innerHTML = days
          hoursSlot.innerHTML = hours
          minutesSlot.innerHTML = minutes
          secondsSlot.innerHTML = seconds
        } else {
          clearInterval(countDownTimerInterval)
          timer.classList.add('!hidden')
        }
      }, 1000)
    }
  }
}

export const setupCountdownTimer = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}